import { QueryClient } from '@tanstack/react-query';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

export const userManagerConfig = new UserManager({
  authority: `${import.meta.env.VITE_APP_AUTHORITY}/auth/realms/${import.meta.env.VITE_APP_REALMS}`,
  client_id: import.meta.env.VITE_APP_CLIENT_ID,
  client_secret: import.meta.env.VITE_APP_CLIENT_SECRET,
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  monitorSession: true, // cho phép phát hiện việc đăng nhập/đăng xuất trên nhiều tab
  response_type: 'code', // Phương thức phản hồi sử dụng Authorization Code Flow
  scope: 'openid profile email', // Phạm vi quyền truy cập yêu cầu: xác thực, hồ sơ và email của người dùng
  loadUserInfo: true, // Tự động tải thêm thông tin người dùng từ đám mây sau khi nhận access token
  automaticSilentRenew: true, // Tự động thực hiện gia hạn token mà không cần tương tác người dùng khi token sắp hết hạn
  includeIdTokenInSilentRenew: true, // Bao gồm id_token trong quá trình gia hạn ẩn để xác thực lại đầy đủ
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }), // Lưu trữ state trong sessionStorage để quản lý quá trình xác thực
  accessTokenExpiringNotificationTimeInSeconds: 60, // Thời gian (giây) để cảnh báo trước khi access token hết hạn và kích hoạt gia hạn
});

export const tanstackQueryClient = new QueryClient();
